export default __webpack_public_path__ + "section-background.53e23c43.svg";